var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ssh-proxy-match-list',{attrs:{"id":_vm.id,"proxyEndpointId":_vm.resId,"getParams":_vm.getParams}})
}
var staticRenderFns = []

export { render, staticRenderFns }